// Generated by CoffeeScript 2.7.0
var Switch;

export default Switch = class Switch {
  constructor(element, option = {}) {
    this.switch_input = DomMaster.wrap(element).node;
    this.current_checked = this.switch_input.checked;
    _.extend(this, option);
    this._init();
    if (option.runCallbacksOnCreate) {
      this._changeFunc();
    }
  }

  _init() {
    // 用 label 包裹的 span 和 checkbox，
    // 当点击 label 的时候，会在 span 和 label 上都触发 click 事件
    // 这个时候只需要保留一个 click 事件，比如 popover 的 trigger 只需要一个事件
    this.switch_input.addEventListener('click', function(event) {
      return event.stopPropagation();
    });
    return this.switch_input.addEventListener('change', (event) => {
      if (this.current_checked !== event.target.checked) {
        this._changeFunc();
      }
      this.current_checked = event.target.checked;
      return event.stopPropagation();
    });
  }

  _changeFunc() {
    if (this.switch_input.checked) {
      return typeof this.switchOnFunc === "function" ? this.switchOnFunc(this) : void 0;
    } else {
      return typeof this.switchOffFunc === "function" ? this.switchOffFunc(this) : void 0;
    }
  }

  change(status) {
    return this.switch_input.checked = status;
  }

};
